<template>
  <div class="card-list-item product-item">
    <div class="helper-button" v-on:click="openLinkedCategories"></div>
    <div class="card-item-main-wrap">
      <div class="card-item-main">
        <div class="card-item-image" v-if="product.file_id" :style="{ backgroundImage: 'url('+productImage+')'}"></div>
        <div :class="'card-item-title product-item-title' + (product.file_id ? ' has-image' : ' no-image')">
          <div class="card-item-name-wrap"><span class="card-item-name product-item-name" v-if="displayName === 'both' || !displayName">{{ $filters.posname(product) }}</span><span class="card-item-name product-item-name" v-if="displayName === 'product'">{{ product.name }}</span><span class="card-item-name product-item-name" v-if="displayName === 'marketing'">{{ $filters.marketingname(product) }}</span></div>
        </div>
      </div>
      <a class="view-button btn btn-default" v-on:click="showPreviewModal"><span class="fa fa-fw fa-info"></span></a>
    </div>

    <div class="product-item-footer card-item-footer">
      <div class="reservable-item-button product-item-button card-item-button">
        <button class="btn btn-default" v-on:click="openLinkedCategories"><span class="hidden-md">{{ _('Select') }}</span><span class="hidden-xs hidden-sm hidden-lg"><span class="fa fa-fw fa-folder-open"></span></span></button>
      </div>
    </div>
    
    <modal :name="previewModalId" :adaptive=true :width=1000 :maxWidth=1000 :maxHeight=500 :scrollable=true height="auto">
      <product-popup :product="product" :shopId="productShopId" :productShopId="productShopId" :baseDomain="baseDomain" :locale="locale" v-on:close="hidePreviewModal"></product-popup>
    </modal>
  </div>  
</template>

<script>

import errors from '~/lib/errors'
import Multiselect from 'vue-multiselect'
import { ProductPopup } from '#components'

export default {
  data () {
    return {
      productCount: 1,
      merchant:{}
    }
  },
  mixins: [ errors ],
  props: ['product', 'productShopId', 'baseDomain', 'column', 'activeComponent', 'displayName'],
  components: {
    Multiselect,
    ProductPopup
  },
  computed: {
    locale () {
      return this.$store.state.locale
    },
    previewModalId () {
      return this.column.identifier + '-component-' + this.activeComponent.id + '-product-' + this.product.id + '-preview'
    },
    productImage () {
      return (this.product.file_id ? this.baseDomain + this.productShopId + '/files/' + this.product.file_id + '.' +this.product.file_ext : 'data:image/gif;base64,R0lGODlhDwAKAJEAAAAAAP///////wAAACH5BAEHAAIALAAAAAAPAAoAAAIKlI+py+0Po5xUFgA7')
    },
    productCountValues () {
      let returnValues = []
      for (let i = 0; i < 50; i++) {
        returnValues.push(i+1)
      }
      return returnValues;
    }
  },
  methods: {
    showPreviewModal () {
      this.$modal.show(this.previewModalId)
    },
    hidePreviewModal () {
      this.$modal.hide(this.previewModalId)
    },
    openLinkedCategories () {
      if(this.product && this.product.ownLinkedcategory && this.product.ownLinkedcategory.length) {
        let categoryIds = []
        for(let i = 0; i < this.product.ownLinkedcategory.length; i++) {
          categoryIds.push(this.product.ownLinkedcategory[i].linkedcategory_id)
        }
        this.$emit('openLinkedCategories', this.product.id, this.productShopId, categoryIds, this.product.name)
      }
    },
    hasSelectableResources () {
      if (!this.product || !this.product.sharedResourcepool || !this.product.sharedResourcepool.length) {
        return false
      }
      for (var i = 0; i < this.product.sharedResourcepool.length; i++) {
        if (parseInt(this.product.sharedResourcepool[i].selectable)) {
          return true
        }
      }
      return false
    },
    selectableResourcePools () {
      let pools = []
      if (!this.product || !this.product.sharedResourcepool || !this.product.sharedResourcepool.length) {
        return pools
      }
      for (var i = 0; i < this.product.sharedResourcepool.length; i++) {
        if (parseInt(this.product.sharedResourcepool[i].selectable) && this.product.sharedResourcepool[i].sharedResource && this.product.sharedResourcepool[i].sharedResource.length > 0) {
          pools.push(this.product.sharedResourcepool[i])
        }
      }
      return pools
    }    
  }
}

</script>